// ----------------------------------------------------------------------
// <copyright file="Izenda.UIContants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {

  var localizer = require('share/localization/Izenda.Localizer');
  var SCHEMA_DEF = {
    get title() { return localizer.getText('FIELD_PROPERTIES_SCHEMA_LABEL_FIELD_PROPERTIES'); },
    schemaKey: 'DATASOURCE_FIELD_PROPERTIES',
    props: {
      className: 'form-horizontal field-props-container'
    },
    fields: {
      wrapperContent: {
        component: 'ScrollBoxContainer',
        props: {
          className: 'scrollbox-container'
        },
        fields: {
          dataSource: {
            component: 'Panel',
            props: {
              initState: true,
              collapsible: true,
              header: {
                get title() { return localizer.getText('COMMON_LABEL_DATA_SOURCE');},
                icon: 'icon-toggle-triangle'
              }
            },


            fields: {
              dataType1: {
                get title() { return localizer.getText('COMMON_LABEL_TYPE')},
                type: 'static',
                fnValue: 'getDataObjectType'
              },

              dataObjectName: {
                get title () { return localizer.getText('COMMON_LABEL_NAME');},
                type: 'static',
                fnValue: 'getDataObjectName'
              },

              name: {
                get title () { return localizer.getText('COMMON_LABEL_FIELD_NAME');},
                type: 'static'
              },

              izendaDataType: {
                get title() { return localizer.getText('COMMON_LABEL_DATA_TYPE');},
                type: 'static'
              }
            }
          }
        }
      }
    }
  };


  module.exports = function (editorComp, reportDesignerModel, fieldStore, itemProps) {
    ensure(!!(reportDesignerModel), 'reportDesignerModel must be set');

    return {
      // define data to render UI
      definedSchema: SCHEMA_DEF,

      // list of widgets which are used to render UI
      widgets: {
        Panel: require('share/components/controls/Izenda.Panel'),
        ScrollBoxContainer: require('share/components/controls/Izenda.ScrollBoxContainer')
      },


      // data to binding to fields
      source: (itemProps && itemProps.itemData) || {},


      // defined-function which fields need to execute to get its data
      mappingSource: {
        getDataObjectName: function () {
          return itemProps.dataObject && itemProps.dataObject.name;
        },

        getDataObjectType: function () {
          return itemProps.dataObject && itemProps.dataObject.type;
        }
      }
    };
  }
} ());



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSourceTree/Izenda.FieldPropertiesSchema.js